(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["likimio-bed-navigation"] && !Shopify.designMode) return;
  try {
    class LikimioBedNavigation extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.details?.querySelector('summary');

      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('focusout', this.onFocusout);
      this.addEventListener('pointerleave', this.onPointerLeave);
      document.addEventListener('pointerdown', this.onDocumentPointerDown);
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('focusout', this.onFocusout);
      this.removeEventListener('pointerleave', this.onPointerLeave);
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
    }

    onKeydown = (event) => {
      if (event.key !== 'Escape' || !this.details?.open) return;

      this.details.open = false;
      this.summary?.focus();
    };

    onFocusout = (event) => {
      if (event.relatedTarget instanceof Node && this.contains(event.relatedTarget)) return;

      this.details?.removeAttribute('open');
    };

    onPointerLeave = () => {
      if (this.matches(':focus-within')) return;

      this.details?.removeAttribute('open');
    };

    onDocumentPointerDown = (event) => {
      if (!(event.target instanceof Node) || this.contains(event.target)) return;

      this.details?.removeAttribute('open');
    };
  }

  if (!customElements.get('likimio-bed-navigation')) {
    customElements.define('likimio-bed-navigation', LikimioBedNavigation);
  }
  } catch(e) { console.error(e); }
})();

})();
